import React from "react";
import { Link, useLocation } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck, faXmark } from "@fortawesome/free-solid-svg-icons";
import siteConfig from "../config/siteConfig";
import "../css/paysuccess.css";

const PaySuccess = () => {
  const { search } = useLocation();
  const state = new URLSearchParams(search).get("state");
  const successful = state === "success";
  const cancelled = state === "cancel";

  return (
    <main className="success-page">
      <section className="success-card" role="status" aria-live="polite" aria-labelledby="payment-title">
        <div className="success-card__mark" aria-hidden="true">
          <FontAwesomeIcon icon={successful ? faCheck : faXmark} />
        </div>
        <p className="success-card__eyebrow">Payment status</p>
        <h1 id="payment-title">
          {successful ? "Payment successful." : cancelled ? "Payment cancelled." : "No payment status found."}
        </h1>
        <p className="success-card__intro">
          {successful
            ? "Thank you. Your payment was accepted and your order is now being prepared. A confirmation will be sent to the email supplied at checkout."
            : "Your order has not been paid. Your cart is still available, so you can review the details and try again when you are ready."}
        </p>
        <p className="success-card__note">
          Need help? Email <a href={`mailto:${siteConfig.contact.supportEmail}`}>{siteConfig.contact.supportEmail}</a>.
        </p>
        <div className="success-card__actions">
          <Link to={successful ? "/shop" : "/checkout"} className="success-card__primary-action">
            {successful ? "Continue shopping" : "Return to checkout"}
          </Link>
          <Link to="/" className="success-card__secondary-action">Return home</Link>
        </div>
      </section>
    </main>
  );
};

export default PaySuccess;
